import { render, staticRenderFns } from "./AnomalySummary.vue?vue&type=template&id=4cc06aea&scoped=true&"
import script from "./AnomalySummary.vue?vue&type=script&lang=js&"
export * from "./AnomalySummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc06aea",
  null
  
)

export default component.exports